import { ChapterEntry, SectionEntry, SectionId, TaskId, TaskType } from "@/types/content-types";
import { createContext, useContext } from "react";
import { ScrollTargetId } from "../../hooks/useScroller";
import { SectionState, TasksByType } from "../appContent/appContentHooks";

type OpenTask = {
    type: TaskType;
    id: TaskId;
    scrollTarget: ScrollTargetId;
};
export type OpenTaskChangeListener = (next: OpenTask, prev: OpenTask) => void;

export type ChapterHandlerContextType = {
    openTask: OpenTask;
    setOpenTask: (taskType: TaskType, scrollTarget?: ScrollTargetId) => void;
    currentSection: SectionState;
    chapter: ChapterEntry;
    isChapterUnlocked: boolean;
    isSectionUnlocked: (sectionId: SectionId) => boolean;
    taskDialogRef: React.MutableRefObject<HTMLElement>;
    setCurrentSectionId: (sectionId: SectionId, { skipProgressionCheck }?: { skipProgressionCheck: boolean }) => void;
    currentTasks: TasksByType;
    currentSectionProgress: number;
    orderedSections: SectionState[];
    sections: Map<SectionId, SectionState>;
    registerOpenTaskChangeListener: (callback: OpenTaskChangeListener) => void;
    deregisterOpenTaskChangeListener: (callback: OpenTaskChangeListener) => void;
};

const ChapterHandlerContext = createContext<ChapterHandlerContextType | undefined>(undefined);
export const ChapterHandlerContextProvider = ChapterHandlerContext.Provider;

export function useChapterHandler() {
    const ctx = useContext(ChapterHandlerContext);
    // if (!ctx) throw new Error("useChapterHandler must be used within a <ChapterHandlerProvider />");
    return ctx;
}